import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { Storage } from  '@ionic/storage';

/*
  Generated class for the Storagehelper provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class Storagehelper {
	public alternativeEvaluationComplete;
	public otherStorageComplete;
	private $self;

	constructor(public http: Http,public storage:Storage) {
		this.alternativeEvaluationComplete=false;
		this.otherStorageComplete=false;

		console.log('Hello Storagehelper Provider');
		this.$self=this;
	}

	saveDataFromServer(serverData:Object){
		return new Promise<String>((resolve,reject)=>{

			console.log("Saving data to database");

			for(let key in serverData){
				if(key=="mylist"){
					var finalData=[];
					this.evaluateUserAddedAlternatives(serverData[key]).then((data1)=>{
							if(this.otherStorageComplete==true){
								resolve();
							}
						
					})
				}else{

					this.removeStorageItem(key).then((data)=>{
						this.setStorageItem(key,serverData[key]).then(()=>{
							if(key=="userthoughts"){
								this.otherStorageComplete=true;
								console.log("Resolving now");
								if(this.alternativeEvaluationComplete==true)
									resolve();
							}
						})
					})
				}
			}
		})
	}

	evaluateUserAddedAlternatives(serverData){
		var finalData=[];
		return new Promise((resolve,reject)=>{
			this.getStorageItem("mylist").then(data=>{
				if(data!=null && data.length>0){
					data.forEach((e,i)=>{



						if(e.userAdded==true){
							var index=serverData.findIndex((e1,i1)=>{
								return e1.group_id==e.server_id;
							})
							if(index!=-1){
								serverData.splice(index,1);
							}
							serverData.push(e);
						}else{
							e.alternatives.forEach((e2,i)=>{
								if(e2.userAdded==true){
										var filtered=serverData.filter((e1,i1)=>{
														return e1.group_id==e.group_id;
													});

										if(filtered.length>0){

											var index=filtered[0].alternatives.findIndex((e3,i3)=>{
												return e3.alternativeId==e2.serverID;
											})
											
											if(index!=-1){
												filtered[0].alternatives.splice(index,1);
											}
											filtered[0].alternatives.push(e2);
										}
								}
							})
						}
					})
				}

				this.removeStorageItem("mylist").then((data)=>{
					this.setStorageItem("mylist",serverData).then(()=>{
						this.alternativeEvaluationComplete=true;
						resolve();
					})
				})
				
			})
		})
		
	}

	setStorageItem(key:string,value:Array<Object>){
		return this.storage.set(key,value);
	}

	getStorageItem(key: string){
		return this.storage.get(key);
	}

	removeStorageItem(key:string){
		return this.storage.remove(key);
	}

	queryStorage(storageKey,key,value){
		return new Promise<Array<Object>>((resolve,reject)=>{
			var result:Array<Object>=[];

			this.getStorageItem(storageKey).then((data:Array<Object>)=>{
				if(data!=null){
					data.forEach((e,i)=>{
						if(e[key]==value){
							result.push(e);
						}
					})
				}
				resolve(result);
			})			
		})
	}

	addNewItem(key,primaryKey,newData){
		return new Promise((resolve,reject)=>{
			this.getStorageItem(key).then((data:Array<Object>)=>{
				var newId=1000;
				if(data==null){
					data=[];
					newData[primaryKey]=1;
				}else{
					data.forEach((e:Object,i)=>{
						if(e[primaryKey]>newId && e[primaryKey]>1000){
							newId=e[primaryKey];
						}
					})
					newData[primaryKey]=newId+1;
				}
				data.push(newData);
				this.removeStorageItem(key).then(()=>{
					this.setStorageItem(key,data).then(()=>{
						resolve(newData[primaryKey]);
					})
				})
			})
		})
	}

	addMultipleItems(key,primaryKey,newMultipleData){
			return new Promise((resolve,reject)=>{
				this.getStorageItem(key).then((data:Array<Object>)=>{
					var newId=1000;
					if(data==null){
						data=[];
						var roll=1;
						newMultipleData.forEach((e,i)=>{
							e[primaryKey]=roll;
							roll++;
						})
					}else{
						data.forEach((e:Object,i)=>{
							if(e[primaryKey]>newId && e[primaryKey]>1000){
								newId=e[primaryKey];
							}
						})
						newMultipleData.forEach((e,i)=>{
							e[primaryKey]=newId+1;
							newId++;
						})
					}
					data=data.concat(newMultipleData);
					this.removeStorageItem(key).then(()=>{
						this.setStorageItem(key,data).then(()=>{
							resolve(newMultipleData.length);
						})
					})
				})
			})
	}

	updateItem(key,primaryField,primaryid,toUpdate){
		return new Promise((resolve,reject)=>{
			this.getStorageItem(key).then((data:Array<Object>)=>{
				var index=data.findIndex((e)=>{
					return e[primaryField]==primaryid
				})
				if(index!=-1){
					toUpdate[primaryField]=primaryid;
					data[index]=toUpdate;
					this.removeStorageItem(key).then(()=>{
						this.setStorageItem(key,data).then(()=>{
							resolve();
						})
					})
				}

			})
		})
	}

	deleteItem(key,primaryField,primaryid){
		return new Promise((resolve,reject)=>{
			this.getStorageItem(key).then((data:Array<Object>)=>{
				if(data!=null && data.length>0){
						var index=data.findIndex((e)=>{
							return e[primaryField]==primaryid
						})
						if(index!=-1){
							data.splice(index,1);
							this.removeStorageItem(key).then(()=>{
								this.setStorageItem(key,data).then(()=>{
									resolve();
								})
							})
						}else{
							resolve();
						}
				}else{
					resolve();
				}
			

			})
		})
	}

	deleteMultipleItems(key,primaryField,primaryid){
		return new Promise((resolve,reject)=>{
			this.getStorageItem(key).then((data:Array<Object>)=>{
				if(data!=null && data.length>0){
						var toremoveIndex=[];
						var index=data.forEach((e,i)=>{
							if(e[primaryField]==primaryid){
								toremoveIndex.push(i);
							}
						})
						if(toremoveIndex.length>0){
							var prevRemoved=0;
							for(var i=0;i<toremoveIndex.length;i++){
								data.splice(toremoveIndex[(i-prevRemoved)],1);
								prevRemoved++;
							}
							
							this.removeStorageItem(key).then(()=>{
								this.setStorageItem(key,data).then(()=>{
									resolve();
								})
							})
						}else{
							resolve();
						}
				}else{
					resolve();
				}
			

			})
		})
	}

	addAlternativeToAlternativeGroup(groupId,alternative,serverID){
		return new Promise((resolve,reject)=>{

			this.getStorageItem("mylist").then((data)=>{
				var filtered=data.filter((e,i)=>{
					return e.group_id==groupId
				})[0];
				var newAlternativeID=this.getHighestAlternativeId(data);
				var alternativeParam={alternativeTitle:alternative,serverID:serverID,alternativeId:newAlternativeID,userAdded:true};
				filtered.alternatives.push(alternativeParam);
				this.removeStorageItem("mylist").then(()=>{
					this.setStorageItem("mylist",data).then(()=>{
						resolve(newAlternativeID);
					})
				})
			})
		})
	}

	getHighestAlternativeId(alternativeGroups){
		var id=1000;
		alternativeGroups.forEach((e,i)=>{
			e.alternatives.forEach((e,i)=>{
				if(e.alternativeId>id && e.alternativeId>1000){
					id=e.alternativeId;
				}
			})
		})
		return (id+1);
	}

}



// WEBPACK FOOTER //
// ./src/providers/storagehelper.ts